module.exports = __webpack_public_path__ + "img/流体力学4_1_3.79dc875a.jpg";